module.exports = __webpack_public_path__ + "img/Dental3d_0.9325a62c.png";